module.exports = __webpack_public_path__ + "static/painting-market-cda3fbebc371aa33b25f50759e0d6630.jpg";